let hasRun = false;

const postInit = () => {
	if (hasRun) return;
	// init code here

	hasRun = true;
};

export default postInit;
